import './styles/tokens.css';
import './styles/app.css';
import './styles/fonts.css';

import { mount } from 'svelte';
import App from './App.svelte';
import { scheduleAnalytics } from './lib/analytics';
import { preloadCriticalFont } from './lib/criticalFont';

preloadCriticalFont();
scheduleAnalytics();

const target = document.getElementById('app');
if (!target) throw new Error('#app mount target not found');

// Dev-only: expose stores so the editing/draw views (auth-gated in prod) can be
// driven from Playwright without a live session. Stripped from prod builds.
if (import.meta.env.DEV) {
  void Promise.all([
    import('./stores/ui.svelte'),
    import('./stores/form.svelte'),
    import('./stores/draw.svelte'),
    import('./stores/sites.svelte'),
    import('./stores/auth.svelte'),
  ]).then(([ui, form, draw, sites, auth]) => {
    (window as unknown as { __stores?: unknown }).__stores = {
      ui: ui.ui,
      form: form.form,
      draw: draw.draw,
      sites: sites.sites,
      auth: auth.auth,
    };
  });
}

export default mount(App, { target });
